export var PartyInventorySharingStateEnum;
(function (PartyInventorySharingStateEnum) {
    PartyInventorySharingStateEnum[PartyInventorySharingStateEnum["OFF"] = 0] = "OFF";
    PartyInventorySharingStateEnum[PartyInventorySharingStateEnum["ON"] = 1] = "ON";
    PartyInventorySharingStateEnum[PartyInventorySharingStateEnum["DELETE_ONLY"] = 2] = "DELETE_ONLY";
})(PartyInventorySharingStateEnum || (PartyInventorySharingStateEnum = {}));
